import { FC, PropsWithChildren } from 'react';

import Picture from 'components/picture';
import { IImageFragment } from 'generated/sanity-graphql';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { t } from 'state/intl/translations';
import { TranslationKey } from 'state/intl/types';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import {
  BenefitText,
  Container,
  ContentText,
  InfoBadge,
  InfoContainer,
  InfoText,
  SectionTitle,
  Title,
} from './styled';

type WalmartMembershipProps = {
  title?: string;
  image?: IImageFragment | null | undefined;
};

export const WalmartMembership: FC<PropsWithChildren<WalmartMembershipProps>> = ({
  title,
  image,
}) => {
  const isMobile = useIsMobileBreakpoint();
  const enableWalmartPlusMonthlyTrialOffer = useFlag(
    LaunchDarklyFlag.ENABLE_WALMART_PLUS_TRIAL_OFFER_MONTHLY
  );

  const text: Record<string, TranslationKey> = enableWalmartPlusMonthlyTrialOffer
    ? {
        sectionTitle: 'dontHaveWalmartAccountMonthly',
        contentText: 'walmartMembershipSignUpMonthly',
        infoText: 'walmartMembershipDealMonthly',
      }
    : {
        sectionTitle: 'dontHaveWalmartAccount',
        contentText: 'walmartMembershipSignUp',
        infoText: 'walmartMembershipDeal',
      };

  return (
    <>
      <SectionTitle>{title || t(text.sectionTitle)}</SectionTitle>
      <Container>
        {image && (
          <Picture
            image={image}
            alt={image.asset.altText}
            height={181}
            width="100%"
            objectFitContain={!isMobile}
            lazy
          />
        )}
        <Title>{t('royalPerksMembersEnjoy')}</Title>
        <BenefitText>{t('walmartPlusBenefit')}</BenefitText>
        <ContentText>{t(text.contentText)}</ContentText>
        <InfoContainer>
          <InfoBadge>
            <InfoText>{t(text.infoText)}</InfoText>
          </InfoBadge>
        </InfoContainer>
      </Container>
    </>
  );
};
